import Vue from 'vue';
import Vuex from 'vuex';

import accounts from './modules/accounts';
import user from './modules/user';
import dex from './modules/dex';
import login from './modules/login';
import location from './modules/location';
import course from './modules/course';
// eslint-disable-next-line import/no-cycle
import pipeline from './modules/pipeline';
import admission from './modules/admission';
import essay from './modules/essay';
import analytics from './modules/analytics';
import RootState from './root_state';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {} as RootState,
  modules: {
    dex,
    accounts,
    user,
    login,
    location,
    course,
    pipeline,
    admission,
    essay,
    analytics,
  },
});
